import { useState, useEffect } from "react";
import Dropdown from "@shared/v2/Dropdown";
import Pagination from "@shared/v2/Pagination";

export const PEOPLE_PER_PAGE = 50;

const navigateTo = (page) => {
  const urlsp = new URL(window.location.href);
  urlsp.searchParams.set("page", page);
  window.location.assign(urlsp);
};

const AllPeoplePagination = () => {
  const currentPage = +new URLSearchParams(window.location.search).get("page") || 1;
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      const total = await (
        await fetch(`${window.location.pathname}/count${window.location.search.replace(/page=\d+/, "")}`)
      ).json();
      setTotalPages(Math.ceil(total.count / PEOPLE_PER_PAGE));
      document.querySelector("#header-count").innerText = `(${total.count.toLocaleString()})`;
    };
    fetchData();
  }, []);

  return (
    totalPages && (
      <div aria-label="Pagination" role="navigation">
        <div className="tw-items-center tw-justify-center tw-flex tw-flex-row tw-h-[56px] tw-w-full">
          <div
            id="page-buttons"
            className="tw-flex tw-flex-row tw-items-center tw-justify-center tw-space-x-1 tw-h-[32px] tw-gap-[8px]"
          >
            <Pagination
              currentPage={currentPage}
              maxCentralNeighbors={4}
              maxEdgeSize={1}
              totalPages={totalPages}
              onGoToPage={(e) => navigateTo(e)}
            />
          </div>
          <div className="tw-items-center tw-justify-center tw-flex tw-flex-row !tw-right-0 tw-mr-[24px] tw-ml-[24px] tw-gap-[12px] tw-absolute tw-w-[172px] tw-h-[36px] max-[500px]:hidden">
            <span className="tw-font-normal tw-text-neutral-gray-50">Jump to page</span>
            <Dropdown
              name="Pagination dropdown."
              className="tw-w-full tw-h-[36px] tw-rounded-[4px] focus:!tw-outline-brivity-blue-100 hover:!tw-border-brivity-blue-100"
              menuPlacement="top"
              options={Array.from({ length: totalPages }, (_, i) => ({ value: i + 1, label: `${i + 1}` }))}
              isSearchable
              onChange={(k) => navigateTo(k.value)}
              placeholder={currentPage}
            />
          </div>
        </div>
      </div>
    )
  );
};

export default AllPeoplePagination;
